
import "vux";
import {SaafHeader, SaafScroller} from "@/common/components/index";
import {mapState} from "vuex";
import {service} from "@/common/index";
import {fetch} from "@/page/index";
import {Dialog} from "vant";
import md5 from 'vux/src/tools/md5/index.js'

import CryptoJS from "crypto-js"
import systemHook from "../../../config/systemHook";
import Base64 from "vux/src/tools/base64";
import RSAUtil from "../../../utils/RSAUtil";
import store from "../../../common/store/StoreCommon";

export default {
data() {
return {
viewHeight: service.getViewHeight(service.componentHeight().native),
page: service.pageServer.newPage(),
list: [],
userObj: {


userName: "",
pwd: "",
verificationCode: "",
lan: "CN",
domain: "http://127.0.0.1:8985",
},
checked: true,
verificationSrc: "",
urlParams: {},


};
},
components: {
SaafHeader,
SaafScroller,
Dialog,
},
computed: {
...mapState({
userInfo: (state) => state.user.userInfo,
menus: (state) => state.user.menus,
}),
},
created() {

console.log("登录页面created，清除旧缓存和Session");




let code = this.getUrlParam('code');

let _userInfo = store.state.user.userInfo;
const href = window.location.href;
if (!code && href.indexOf('action') < 0 && !this.$route.query.action) {

this.wechatAuthorize()
}



localStorage.removeItem("routeParentParams")

},
mounted() {
if (!!this.$route.query.action) {
this.singleFlag = "Y"
this.$nextTick(() => {
let _actionParams = new RSAUtil().decrypt(this.$route.query.action, systemHook.getRsaPublicKey())
this.userObj = JSON.parse(_actionParams)
console.log("userObj",this.userObj);
this.handleSingleLogin()
})
}else{

console.log("process.env.VUE_APP_SAAF_PLATFORM",process.env.VUE_APP_SAAF_PLATFORM)
let _userInfo = localStorage.getItem("userInfo")
if(!!_userInfo) {
console.log("已登录，返回主页")
this.$router.replace({path: '/home', name: 'home'});
}
}

let code = this.getUrlParam('code');
if (!!code) {
this.wxLogin(code);
}

},
activated: function () {
this.findList();
},
methods: {
handleSingleLogin(){
fetch.login({
userName: this.userObj.userName,
pwd: md5("" + this.userObj.pwd + "lo0.1l@g9v#"),
lan: this.userObj.lan,
singleFlag: md5("Ylo0.1l@g9v#"),
domain: this.userObj.domain,
verificationCode: this.userObj.verificationCode,
}).then((res) => {
console.log("res",res);
if (res.status === "S") {
this.initLogin(res)
}
});
},

autoLogin() {
console.log(this.userInfo)
if (!!this.userInfo && !!!this.userInfo.userName) {
this.userObj.userName = this.userInfo.userName
this.userObj.pwd = CryptoJS.enc.Utf8.stringify(CryptoJS.enc.Base64.parse(this.userInfo.encryptPwd))
this.onSubmit({})
}
},
findList(p) {
if (p === 0) {
this.$refs.SaafScroller.scrollTo(0, 0, 0);
this.page = service.pageServer.newPage();
}
},
listLookupValues() {
fetch.baseLookupTypeService_findDic().then(res=>{
localStorage.setItem("lookupValues", JSON.stringify(res.data));
this.$store.commit('SET_DIC_CODES', res.data)
})
},
onSubmit() {
if (!this.checked) {
Dialog.alert({ message: "请先阅读并同意《协议》" });
return;
}
fetch.login({
userName: this.userObj.userName,
pwd: md5("" + this.userObj.pwd + "lo0.1l@g9v#"),
verificationCode: this.userObj.verificationCode,
lan: this.userObj.lan,
domain: this.userObj.domain,
singleFlag: this.userObj.singleFlag
}).then((res) => {
if (res.status === "S") {
this.initLogin(res)
}
});
},
requestVerifySrc() {
fetch.generateRandomValidate({
lan: this.userObj.lan,
}).then((res) => {
console.log(res);
if (res.status === "S") {
if (res.status === "S") {
this.verificationSrc = res.data;
}
}
});
},
requestMenu(list) {
let _path = false;
let _routePush = () => {
this.$router.push("/TabPage");
_path = true
}

const mobileList = list.filter((item) => item.systemCode === "MOBILE");

if (mobileList.length === 0) {
this.$store.commit("CLEAR_MENU", {})
}
console.log("mobileList",mobileList);
mobileList.forEach((item, index) => {
if (index === 0) {
this.$store.commit("SET_RESPONSIBILITY", item.responsibilityId);
}
fetch.findBaseMenuByRespId({
lan: item.lan,
isValid: true,
systemCode: item.systemCode,
responsibilityId: item.responsibilityId,
}).then((res) => {
if (res.status === "S") {
const menu = res.data;
console.log("menu",menu);
this.$store.commit("ADD_MENU", {
key: item.responsibilityId,
value: menu,

});
setTimeout(() => {
if (!!!_path) {
_routePush()
}
}, 100)
}
});
});

if (mobileList.length === 0 && !!!_path) {

console.log("_path",_path);
_routePush()
}
},
initLanguage(lanList) {
if (lanList && lanList.length != 0) {
this.$store.commit("SET_LANGUAGE", lanList[0].lookupCode);
}
},
onProtocol() {
Dialog.alert({
title: "协议",
message: `扬农SRM系统平台致力于构建公开、透明的合作环境，根据《中华人民共和国著作权法》、《全国人大常委会关于维护互联网安全的决定》、《互联网信息服务管理工作办法》、《互联网电子公告服务管理规定》等有关法律、法规，制订以下条款：
一、服务条款的确认和接纳
扬农SRM系统平台的所有权、运营权和解释权等其他与本管理平台相关的权利归广州扬农信息科技股份有限公司全权享有。用户进入供应链采购管理平台，必须完全、严格遵守本网站相关条款，包括本服务条款。用户通过点击服务条款中的“我同意”按钮，并且完成供应链采购管理平台注册用户注册程序，表示用户与供应链采购管理平台网站管理单位达成注册用户服务使用协议，接受供应链采购管理平台注册用户服务条款全部内容。用户通过点击网站其它相关位置上的“我同意”按钮，亦表示完全接受了该按钮相关文件中的全部内容。
二、有关用户资料
用户同意：
1）在申请使用供应链采购管理平台提供的服务时，向供应链采购管理平台提供真实、准确、完整的单位和/或个人资料。
三、知识产权


四、免责声明


五、其他（所有保释权归***公司所有）`,
});
},
getUrlParam(paramName) {

let params = window.location.search

if (params.indexOf(paramName) > -1) {
let paramValue = ''
paramValue = params.substring(params.indexOf(paramName), params.length)

if (paramValue.indexOf('&') > -1) {

paramValue = paramValue.substring(0, paramValue.indexOf('&'))
}

paramValue = paramValue.replace(paramName + '=', '')
return paramValue
}
},
getUrlAllParam() {

let _params = window.location.search;
_params = _params.substring(1, _params.length);
let _paramsArr = _params.split('&');
for (let i = 0; i < _paramsArr.length; i++) {
let _paramsArrItem = _paramsArr[i].split('=');
this.urlParams[_paramsArrItem[0]] = _paramsArrItem[1];
}

if (!!this.urlParams.singleEndpoint) {
localStorage.setItem('singleEndpoint', JSON.stringify(this.urlParams))
}
},
/**微信公众号登录*/
wxLogin(code) {
fetch.wechat_login({
lan: this.userObj.lan,
domain: this.userObj.domain,
code: code,
}).then((res) => {
if (res.data && (res.code === "S" || res.code === "200" || res.status === "200")) {
this.initLogin(res)
} else {

localStorage.removeItem("redirect");

window.location.href = "https://login.yangnongchem.com/api/oauth/authorize?redirect_uri=" +
"https://ynsrm.yangnongchem.com/api/baseServer/baseLoginService/mobileSingleRedirect&client_id=2E91066434B320DE7FEF&scope=user&response_type=code";

}
}).catch((err) => {
localStorage.removeItem("redirect");

window.location.href = "https://login.yangnongchem.com/api/oauth/authorize?redirect_uri=" +
"https://ynsrm.yangnongchem.com/api/baseServer/baseLoginService/mobileSingleRedirect&client_id=2E91066434B320DE7FEF&scope=user&response_type=code";

});
},
/**企业微信登录*/


















/**初始化登录后信息*/
initLogin(res) {
const userInfo = res.data;
const userJson = userInfo ? JSON.stringify(userInfo) : "";
localStorage.setItem("userInfo", userJson);
this.$store.commit("INIT_USER_INFO");
if (!!userInfo) {
this.requestMenu(userInfo.userRespList);
this.initLanguage(userInfo.languageList);
this.listLookupValues();
}
},
/**微信公众号Oauth2.0身份认证*/
wechatAuthorize() {
let _appId = systemHook.config.wechat.appId
let _wechatUrl = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + _appId + "&redirect_uri="

_wechatUrl += encodeURIComponent(systemHook.config.wechat.redirectUri)
_wechatUrl += "&response_type=code&scope=snsapi_base&state=" + systemHook.config.wechat.state +"&connect_redirect=1#wechat_redirect"
window.location.href = _wechatUrl
},
/**企业微信Oauth2.0身份认证*/










































































},
watch: {},
};



// WEBPACK FOOTER //
// ./src/page/srm/login/login.vue